export default __webpack_public_path__ + "static/media/wheader.edab8f48.png";